import { takeRight } from 'lodash'
import { useState } from 'react'

import Tag from '@/components/Tag/Tag'
import Tooltip from '@/components/Tooltip/Tooltip'
import TruncateElementsList from '@/components/common/TruncateElementsList'
import type { IdAndName } from '@/types/id-and-name'
import { joinNameArray } from '@/utils/join-array'

import styles from './PreferredRoomsColumn.module.scss'

type PreferredRoomsColumnProps = {
  preferredRooms: IdAndName[] | null
}

const PreferredRoomsColumn = (props: PreferredRoomsColumnProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!props.preferredRooms) return null

  return (
    <TruncateElementsList
      className={styles.wrapper}
      expanded={isExpanded}
      onExpandedChange={setIsExpanded}
      elipsis={hiddenItemsCount => (
        <Tooltip
          text={joinNameArray(
            takeRight(props.preferredRooms, hiddenItemsCount)
          )}
          trigger={
            <Tag
              color="white"
              variant="with-background"
              label={`+${hiddenItemsCount}`}
              onClick={() => {
                setIsExpanded(true)
              }}
            />
          }
        />
      )}
    >
      {props.preferredRooms.map(preferredRoom => (
        <p className={styles.paragraph} key={preferredRoom.id}>
          {preferredRoom.name}
        </p>
      ))}
    </TruncateElementsList>
  )
}

export default PreferredRoomsColumn
